import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

export interface ConfirmDialogData {
  title: string;
  message: string;
  isInput?: boolean;      // If true, shows a text area
  inputLabel?: string;    // Label for the text area
  confirmText?: string;   // Text for the confirm button (e.g., 'Approve', 'Reject')
  confirmColor?: 'primary' | 'warn' | 'accent'; // Color of the confirm button
}

@Component({
  selector: 'app-confirm-action-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, FormsModule],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p class="mb-15">{{ data.message }}</p>
      
      <!-- Input Field (Only visible if isInput is true) -->
      <mat-form-field *ngIf="data.isInput" appearance="outline" class="w-100" style="width: 100%;">
        <mat-label>{{ data.inputLabel || 'Reason' }}</mat-label>
        <textarea matInput [(ngModel)]="inputValue" rows="4" placeholder="Type here..."></textarea>
      </mat-form-field>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button 
              [color]="data.confirmColor || 'primary'" 
              (click)="onConfirm()"
              [disabled]="data.isInput && !inputValue">
        {{ data.confirmText || 'Confirm' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .w-100 { width: 100%; }
    .mb-15 { margin-bottom: 15px; }
  `]
})
export class ConfirmActionDialogComponent {
  inputValue: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  onConfirm(): void {
    // Return object with confirmed status and the input value
    this.dialogRef.close({ confirmed: true, value: this.inputValue });
  }
}